import Backbone from 'backbone';
import $ from 'jquery';

import notifications from 'notifications';
import * as popup from 'Popup';

interface OrganizationRowOptions extends Backbone.ViewOptions<Backbone.Model> {
  removeCallback: () => void;
}

class OrganizationRow extends Backbone.View<Backbone.Model> {
  removeCallback!: () => void;

  constructor(options: OrganizationRowOptions) {
    super(options);
  }

  static initClass(): void {
    // @ts-expect-error: Backbone events can be either the events hash or a method returning the events
    // hash. The Backbone types do not know about this.
    this.prototype.events = {'click .leave-button': 'leaveOrg'};
  }

  override initialize(options: OrganizationRowOptions): void {
    this.removeCallback = options.removeCallback;
  }

  override remove(): this {
    super.remove();
    this.removeCallback();
    return this;
  }

  leaveOrg(): void {
    const organizationId = this.$el.data('organizationId');
    const organizationHandle = this.$el.data('organizationHandle');
    const msg = `Are you sure you want to leave ${organizationHandle}? You'll lose access to all shared items including folders and sequences.`;

    const callback = (): void => {
      $.ajax({
        url: `/1/api/organizations/${organizationId}/users/me`,
        type: 'DELETE',
      })
        .fail(notifications.notifyError)
        .done(() => this.remove());
    };

    new popup.Confirm({title: `Leaving ${organizationHandle}`, msg})
      .choice('Confirm Leaving', 'btn-af-danger', callback)
      .choice('Cancel', 'btn-af-default')
      .show();
  }
}
OrganizationRow.initClass();

class ManageOrganizationsView extends Backbone.View<Backbone.Model> {
  rows: Array<OrganizationRow> = [];

  static initClass(): void {
    this.prototype.el = '#organizations';
  }

  override render(): this {
    const removeCallback = (): void => {
      if (this.$el.find('.organizations-list li').length === 0) {
        this.$el.find('.no-organizations').removeClass('hidden');
      }
    };

    this.rows = this.$el
      .find('.organizations-list li')
      .toArray()
      .map((row) => new OrganizationRow({el: row, removeCallback}));

    return this;
  }
}
ManageOrganizationsView.initClass();

export default ManageOrganizationsView;
